export function isMockingEnabled(): boolean {
  return process.env.REACT_APP_ENABLE_MOCKS === 'true';
}
